export default "__VITE_ASSET__CZE3GjMZ__"